Backbone = require 'backbone'
Backbone.$ = $

class SupportServiceActionsBaseView extends Backbone.View
  linkIdentifier: () ->
    'LINK'

  defaultButtonIdentifier: () ->
    "DEFAULT_BUTTON"

  secondaryButtonIdentifier: () ->
    'SECONDARY_BUTTON'

  setButtonType: (button_type) ->
    @button_type = button_type

  buttonHash:  ->
    switch(@button_type)
      when @linkIdentifier()
        {
          showLinkCTA: true
        }
      when @secondaryButtonIdentifier()
        {
          showSecondaryCTA: true
        }
      else
        {
          showDefaultCTA: true
        }

  isSingleGroupon: () ->
    (@order.groupons.length is 1)

  extendSingleGrouponParams: (hash) ->
    hash.showHyperlink = true
    _.extend hash, {grouponId: @order.groupons[0].id}

  extendHash: (hash) ->
    _.extend hash, @buttonHash() , window.getOrderInfoForBH(@order)

module.exports = SupportServiceActionsBaseView
